import React, { Component } from 'react'
import './Transcript.css'
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import QRCode from 'qrcode.react';
import _, { orderBy } from "lodash";
import axios from "axios";
import { HOST } from "../../../config";


export default class Transcript extends Component {
    constructor(props) {
        super(props)
        this.url = new URLSearchParams(window.location.search).toString();
        this.st = new URLSearchParams(window.location.search).get("st");
        this.gr = new URLSearchParams(window.location.search).get("gr");
        this.elHeight = document.getElementById('A4')
        var today = new Date(),
            date = today.getDate() + '.' + (today.getMonth().length < 8 ? '0' : '') + (today.getMonth() + 1) + '.' + today.getFullYear();
        // datetime = (today.getDate() + '.' + (today.getMonth() + 1) + '.' + today.getFullYear() + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds())
        this.state = {
            // currentDateTime: datetime,
            currentDate: date,
            TRANSCRIPT: [],
            FooterTrans: [],
            heightA4: 0
        }
    }
    componentDidMount() {
        this.postTRANSCRIPT(this.st, this.gr)
        this.setState({
            heightA4: document.getElementById('A4')
        })
    }
    postTRANSCRIPT = (id_student, id_group) => {
        const data = new FormData();
        data.append("id_student", id_student);
        data.append("id_group", id_group);
        axios
            .post(HOST + `/api/okno/transcript?`, data)
            .then((response) => response.data)
            .then((json) => {
                if (json.TRANSCRIPT && json.TRANSCRIPT[0] && json.TRANSCRIPT[0].length) {
                    const Filtered_Transcript = (_.chain(json.TRANSCRIPT[0])
                        .groupBy("id_group")
                        .map((value) => ({
                            mo: value[0].mo,
                            v2: value[0].v2,
                            spec: value[0].spec,
                            faculty: value[0]['p23-2'],
                            s_fio: value[0].s_fio,
                            idid: value[0].idid,
                            BirthDate: value[0].BirthDate,
                            kredits_avg: value[0].kredits_avg,
                            kredits_sum: value[0].kredits_sum,
                            vxGroup_TR_by_id_a_year: _.chain(value)
                                .groupBy("id_a_year")
                                .map((by_year) => ({
                                    p32: by_year[0].p32,
                                    vxGroup_TR_by_id_w_s: _.chain(by_year)
                                        .groupBy("ws_sort")
                                        // .orderBy('ws_sort', 'desc')
                                        .map((by_w_s) => ({
                                            p42: by_w_s[0].p42,
                                            vxDisciplineList: _.chain(by_w_s)
                                                .map((discipline) => ({
                                                    p32: discipline.p32,
                                                    p42: discipline.p42,
                                                    code_discipline: discipline.code_discipline,
                                                    p34: discipline.p34,
                                                    p30: discipline.p30,
                                                    kredits: discipline.kredits,
                                                    ekv_num: discipline.ekv_num,
                                                    ekv_bukv: discipline.ekv_bukv,
                                                    p31: discipline.p31,
                                                }))
                                                .value()
                                        }))
                                        .value()
                                }))
                                .value()
                        }))
                        .value()
                    )
                    setTimeout(() => {
                        this.setState({
                            TRANSCRIPT: Filtered_Transcript,
                            FooterTrans: json.TRANSCRIPT[1]

                        });
                    }, 150);
                } else {
                    this.setState({
                        TRANSCRIPT: [],
                        FooterTrans: []
                    });
                }

            });
    }

    selectLanguage(language) {
        this.props.selectLanguage(language)
    }

    render() {

        if (this.elHeight && this.elHeight == null) return null
        // console.log("elHeight", this.elHeight.clientHeight)
        const { TRANSCRIPT, FooterTrans } = this.state
        if (TRANSCRIPT && !TRANSCRIPT.length && FooterTrans && !FooterTrans.length) return null
        console.log("TRANSCRIPT", TRANSCRIPT)

        return (
            <div className="TRANSCRIPT" >
                <div className='D_main_header' >
                    <header>
                        <a href='/'> <i className="fas fa-arrow-left" ></i></a>
                        <ReactToPrint content={() => this.componentRef}>
                            <PrintContextConsumer>
                                {({ handlePrint }) => (
                                    <i onClick={handlePrint} className="fa fa-print" title="Печать"></i>
                                )}

                            </PrintContextConsumer>
                        </ReactToPrint>
                        {this.props.language === 1 ? <h2> Транскрипт</h2> : <h2> Транскрипт</h2>}
                        {/* <div className='Language'>
                        <h4 onClick={() => this.selectLanguage(1)} className={this.props.language === 1 ? 'Lang_Active' : 'Lang'}>Рус</h4>
                        <h4 onClick={() => this.selectLanguage(2)} className={this.props.language === 2 ? 'Lang_Active' : 'Lang'}>Кырг</h4>
                    </div> */}
                    </header>

                    <div className="Transcript" ref={el => (this.componentRef = el)} id="A4" >
                        <h3>{TRANSCRIPT[0].mo}</h3>
                        <h3>{TRANSCRIPT[0].v2}</h3>
                        <h3>{TRANSCRIPT[0].faculty}</h3>
                        <h3>ТРАНСКРИПТ</h3>
                        <div className='Transcript_body'>
                            <div>
                                <p>ФИО:</p>
                                <p>{TRANSCRIPT[0].s_fio}</p>
                            </div>
                            <div>
                                <p>ID студента:</p>
                                <p>{TRANSCRIPT[0].idid}</p>
                            </div>
                            <div>
                                <p>Дата рождения:</p>
                                <p>{TRANSCRIPT[0].BirthDate}</p>
                            </div>
                            <div>
                                <p>Направление:</p>
                                <p>{TRANSCRIPT[0].spec}</p>
                            </div>
                            <div>
                                <p>Общий GPA:</p>
                                <p>{Math.round(TRANSCRIPT[0].kredits_avg * 100) / 100}</p>
                            </div>
                            <div>
                                <p>Всего зарегистрированых кредитов:</p>
                                <p>{TRANSCRIPT[0].kredits_sum}</p>
                            </div>
                        </div>
                        <div className="table_container">
                            {TRANSCRIPT[0].vxGroup_TR_by_id_a_year.map((year) => {
                                return (
                                    <div>
                                        <h3>{year.p32 + ' учебный год'}</h3>
                                        {year.vxGroup_TR_by_id_w_s.map((semester) => {
                                            return (
                                                <div>
                                                    <p>{semester.p42}</p>
                                                    <table>
                                                        <thead>
                                                            <tr>
                                                                <th>Код дисциплины </th>
                                                                <th>Дисциплина </th>
                                                                <th>Форма контроли </th>
                                                                <th>Кол. кредитов</th>
                                                                <th>Цифр. Эквив.</th>
                                                                <th>Буквен. система</th>
                                                                <th>Традиц. ситема</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {semester.vxDisciplineList.map((disciplines) => {
                                                                return (
                                                                    <tr>
                                                                        <td>{disciplines.code_discipline}</td>
                                                                        <td style={{ textAlign: 'left' }}>{disciplines.p34}</td>
                                                                        <td>{disciplines.p30}</td>
                                                                        <td>{disciplines.kredits}</td>
                                                                        <td>{disciplines.ekv_num}</td>
                                                                        <td>{disciplines.ekv_bukv}</td>
                                                                        <td>{disciplines.p31}</td>
                                                                    </tr>
                                                                )
                                                            })
                                                            }
                                                            <tr>
                                                                <td colSpan='3' style={{ textAlign: 'end', fontWeight: '600' }}>Зарегистрировано кредитов:</td>
                                                                <td style={{ borderRight: 'none', fontWeight: '600' }}>{semester.vxDisciplineList.reduce((a, v) => a = a + v.kredits, 0)}</td>
                                                                <td style={{ borderLeft: 'none' }} colSpan='3'></td>
                                                            </tr>
                                                            <tr className='last_tr'>
                                                                <td colSpan='3'>Всего зарегистрированых кредитов-<span>{TRANSCRIPT[0].kredits_sum}</span></td>
                                                                <td colSpan='4'>Кумулятивный GPA <span>{Math.round(TRANSCRIPT[0].kredits_avg * 100) / 100}</span></td>
                                                            </tr>

                                                        </tbody>
                                                    </table>
                                                </div>
                                            )
                                        })
                                        }
                                    </div>
                                )
                            })}

                        </div>
                        <div className='Footer_Transcript'>
                            <div>
                                <p>{FooterTrans[0].filds1}  {FooterTrans[0].filds2}</p>
                                <p>{FooterTrans[1].filds1}  {FooterTrans[1].filds2}</p>
                                <p>{FooterTrans[2].filds1}  {FooterTrans[2].filds2}</p>
                            </div>
                        </div>
                        <h4>ПРИМЕЧАНИЕ: 1 кредит составляет 30 академических часов.</h4>


                        <QRCode
                            id="qrCodeEl"
                            value={`${window.location.origin}/?page=${'Transcriptt'}&${Buffer.from(`${window.location.search.length}${Buffer.from(`${window.location.search.split('&')[1]}&${window.location.search.split('&')[2]}`).toString('base64')}`).toString('base64')}`} />
                    </div>

                </div>
            </div>
        )
    }
}


